
import Vue from 'vue';
import { mapState } from 'vuex';

import i18n from '@/i18n';
import { ListStatus } from '@/store/types';
import SelectInput from '@/components/controls/select-input.vue';

export default Vue.extend({
  name: 'CountrySelectionControl',
  inheritAttrs: false,
  inject: ['$validator'],
  components: {
    SelectInput,
  },
  props: {
    name: {
      type: String,
      default: 'country',
    },
    label: {
      type: String,
      default: i18n.t('Country'),
    },
    value: {
      type: Number,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * When set to a non-empty array, only countries whose `regionId` is in this list are shown.
     * `null` or `undefined` means no filtering (all countries).
     */
    limitToRegion: {
      type: Array as () => number[] | null | undefined,
      default: undefined,
    },
  },
  computed: {
    ...mapState({
      countries: 'countries',
      countriesStatus: 'countriesStatus',
    }),
    filteredCountries() {
      const list = this.countries as { id: number | string; regionId?: number | string }[];
      if (!this.limitToRegion || this.limitToRegion.length < 1) {
        return list;
      }
      const allow = new Set(this.limitToRegion.map((id) => String(id)));
      return list.filter((c) => c.regionId != null && c.regionId !== '' && allow.has(String(c.regionId)));
    },
    areCountriesLoaded() {
      return this.countriesStatus === ListStatus.Loaded;
    },
    stringifiedValue() {
      return this.value ? String(this.value) : '';
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value);
    },
  },
});
